import api from '@/api/api_geodp'

export default class ResultPaymentService {
  retrieveMessage (idOp) {
    // Mock data.
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       status: 0,
    //       item: '[MOCK DATA] Le réglement est en cours de traitement par le service PAYFIP.',
    //       error: {
    //         code: 0,
    //         message: "[MOCK DATA] Cet idOp n'existe pas."
    //       },
    //       success: true
    //     })
    //   }, 500)
    // })

    return api.get('invoices/' + idOp + '/status')
      .then((response) => {
        return new Promise((resolve) => { resolve(response.data) })
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== '500' && error.response.data) {
            return new Promise((resolve) => { resolve(error.response.data) })
          }
        }
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/resultPaymentService.js